// #region Step name constants
const DOWNLOAD_TEMPLATE_STEP_NAME = 'download-template';
export const SELECT_FACILITY_STEP_NAME = 'facility';
export const UPLOAD_TEMPLATE_STEP_NAME = 'upload';
export const REVIEW_IMPORT_STEP_NAME = 'review';
export const RESULTS_STEP_NAME = 'results';

const BULK_IMPORT_STEPS_URL_PATHNAMES = [
  DOWNLOAD_TEMPLATE_STEP_NAME,
  SELECT_FACILITY_STEP_NAME,
  UPLOAD_TEMPLATE_STEP_NAME,
  REVIEW_IMPORT_STEP_NAME,
  RESULTS_STEP_NAME,
];

export function getBulkImportStepNumber(
  url: URL
):
  | { success: true; value: number; maybeStepName?: never }
  | { success: false; value?: never; maybeStepName: string | undefined } {
  const maybeStepName = url.pathname.split('/').pop()?.replace('.data', '');

  if (!maybeStepName) {
    return { success: false, maybeStepName };
  }

  const currentStepIndex =
    BULK_IMPORT_STEPS_URL_PATHNAMES.indexOf(maybeStepName);

  if (currentStepIndex === -1) {
    return { success: false, maybeStepName };
  }

  const currentStepNumber = currentStepIndex + 1;
  return { success: true, value: currentStepNumber };
}
// #endregion Step name constants

// #region Step 1: Download Template
export const step0Name = BULK_IMPORT_STEPS_URL_PATHNAMES[0];
export function getStep0Pathname() {
  return `/users/bulk-import/${step0Name}`;
}

// #endregion Step 1: Download Template

// #region Step 2: Select Facility
export const FORM_VALUE_SELECTED_FACILITY = 'selected-facility';
export const SELECTED_FACILITY_SEARCH_PARAM = 'facility';
export function getSelectFacilityStepPathname() {
  return `/users/bulk-import/${SELECT_FACILITY_STEP_NAME}`;
}
// #endregion Step 2: Select Facility

// #region Step 3: Upload Template
export function getUploadStepPathname(props: {
  facility: string;
  searchParams: URLSearchParams;
}) {
  const { facility, searchParams } = props;
  const newSearchParams = new URLSearchParams(searchParams);
  newSearchParams.set(SELECTED_FACILITY_SEARCH_PARAM, facility);

  return `/users/bulk-import/${UPLOAD_TEMPLATE_STEP_NAME}?${newSearchParams}`;
}

export const FORM_KEY_UPLOAD_FACILITY_ID = 'upload-facility-id';
export const FORM_KEY_UPLOAD_FILE = 'upload-file';
// #endregion Step 3: Upload Template

// #region Step 4: Review Import
export const KV_FILE_ID_SEARCH_PARAM = 'file-id';
export const REVIEW_IMPORT_URL_PATH = `/users/bulk-import/${REVIEW_IMPORT_STEP_NAME}`;
export function getReviewImportPathname(props: {
  fileId: string;
  facility: string;
  searchParams: URLSearchParams;
}) {
  const { fileId, facility, searchParams } = props;
  const newSearchParams = new URLSearchParams(searchParams);
  newSearchParams.set(SELECTED_FACILITY_SEARCH_PARAM, facility);
  newSearchParams.set(KV_FILE_ID_SEARCH_PARAM, fileId);

  return `${REVIEW_IMPORT_URL_PATH}?${newSearchParams}`;
}
// #endregion Step 4: Review Import
